module.exports = __webpack_public_path__ + "img/13.cd0367f0.png";